import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  TextField,
  Typography,
} from "@mui/material";

import CustomizedSteppers from "./Stepper";

const CustomModal = ({
  title,
  openModal,
  closeModal,
  content,
  actionTitle,
  actionTitle2,
  actionColor,
  actionColor2,
  setConfirmProp,
  setConfirmProp2,
  handleInputChange,
  disputeMessage,
  showTextBox,
}) => {
  const handleConfirmProp = () => {
    setConfirmProp(true);
    closeModal();
  };

  const handleConfirmProp2 = () => {
    setConfirmProp2(true);
    closeModal();
  };

  return (
    <Dialog
      open={openModal}
      onClose={closeModal}
      aria-labelledby="alert-dialog"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "16px",
          width: { xs: "90%", sm: "50%", md: "35%" },
          maxHeight: { md: "80%", xs: "80%", sm: "80%" },
          backgroundColor: "#1a1a1a",
          border: "1px solid #2a2a2a",
          color: "#fff",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography textAlign={"center"} sx={{ color: "#fff", fontWeight: 800, fontSize: "16px" }}>
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <CustomizedSteppers activeStep={1} />
        <DialogContentText id="alert-dialog-description" sx={{ color: "#888", fontSize: "14px" }}>
          <p>
            {content?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </DialogContentText>

        {showTextBox && (
          <Box mt={2}>
            <TextField
              placeholder={"Please write the reason here..."}
              value={disputeMessage}
              onChange={handleInputChange}
              fullWidth
              multiline
              rows={6}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "rgba(255,255,255,0.04)",
                  color: "#fff",
                  borderRadius: "10px",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
                  "&:hover fieldset": { borderColor: "#FFC001" },
                  "&.Mui-focused fieldset": { borderColor: "#FFC001" },
                },
                "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.3)", opacity: 1 },
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions display="flex" flex={1} sx={{ px: 2, pb: 2 }}>
        <Box width="100%" justifyContent={"space-between"} display={"flex"}>
          <Button sx={{ color: "#666", textTransform: "none", fontWeight: 600 }} onClick={closeModal}>
            Cancel
          </Button>
          <Button
            sx={{ color: actionColor, fontWeight: 700, textTransform: "none" }}
            autoFocus
            onClick={handleConfirmProp}
            disabled={disputeMessage ? false : true}
          >
            {actionTitle}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
